(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-collection-filters]');
    if (!root) return;

    var form = root.closest('form');

    // Checking a value re-runs the query straight away; the price range keeps
    // its own submit button because typing shouldn't fire a request per digit.
    root.querySelectorAll('[data-auto-submit]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (form) form.submit();
      });
    });

    var toggles = document.querySelectorAll('[data-filters-toggle]');

    function setOpen(open) {
      root.classList.toggle('is-open', open);
      document.body.classList.toggle('filters-drawer-open', open);
      toggles.forEach(function (btn) {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setOpen(!root.classList.contains('is-open'));
      });
    });

    root.querySelectorAll('[data-filters-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-toolbar"] && !Shopify.designMode) return;
  try {
    (function () {
    var toolbar = document.querySelector('[data-collection-toolbar]');
    if (!toolbar) return;
    var form = toolbar.closest('form');
    var grid = document.querySelector('.product-grid__items');

    function animateReorder(mutate) {
      if (!grid) { mutate(); return; }
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) { mutate(); return; }

      if (document.startViewTransition) {
        document.startViewTransition(mutate);
      } else {
        // FLIP-style fallback: snapshot positions, mutate, then animate deltas.
        var children = Array.prototype.slice.call(grid.children);
        var firstRects = children.map(function (el) { return el.getBoundingClientRect(); });
        mutate();
        var lastRects = children.map(function (el) { return el.getBoundingClientRect(); });
        children.forEach(function (el, i) {
          var dx = firstRects[i].left - lastRects[i].left;
          var dy = firstRects[i].top - lastRects[i].top;
          if (dx || dy) {
            el.animate(
              [
                { transform: 'translate(' + dx + 'px, ' + dy + 'px)' },
                { transform: 'translate(0, 0)' }
              ],
              { duration: 450, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
            );
          }
        });
        grid.classList.add('is-reordering');
        setTimeout(function () { grid.classList.remove('is-reordering'); }, 500);
      }
    }

    // Auto-submit on sort change.
    toolbar.querySelectorAll('[data-auto-submit]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (form) form.submit();
      });
    });

    // Close other dropdowns when one opens.
    var dropdowns = toolbar.querySelectorAll('[data-toolbar-dropdown]');
    dropdowns.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) {
          dropdowns.forEach(function (other) {
            if (other !== d) other.open = false;
          });
        }
      });
    });

    // The sort dropdown doubles as a drawer on narrow screens: lock the page
    // behind it, and give it the close affordances `<details>` lacks.
    var sortDropdown = toolbar.querySelector('[data-sort-dropdown]');
    if (sortDropdown) {
      sortDropdown.addEventListener('toggle', function () {
        document.body.classList.toggle('sort-drawer-open', sortDropdown.open);
      });

      sortDropdown.querySelectorAll('[data-sort-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          sortDropdown.open = false;
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') sortDropdown.open = false;
      });
    }

    // Close on outside click.
    document.addEventListener('click', function (e) {
      if (!toolbar.contains(e.target)) {
        dropdowns.forEach(function (d) { d.open = false; });
      }
    });

    // Layout density toggle con persistencia en sessionStorage y URL
    var layoutBtns = toolbar.querySelectorAll('.collection-toolbar__layout-btn');

    // 1. Prioridad: 1° URL, 2° sessionStorage (memoria del navegador), 3° 'comfortable' por defecto.
    var urlParams = new URLSearchParams(window.location.search);
    var currentLayout = urlParams.get('layout') || sessionStorage.getItem('storefront_layout') || 'comfortable';

    // Guardamos inmediatamente en la sesión para asegurar el tiro
    sessionStorage.setItem('storefront_layout', currentLayout);

    // 2. Aplicamos el estado inicial al cargar la página (se ejecuta en la pág 1, 2, etc.)
    if (grid) grid.dataset.layout = currentLayout;
    layoutBtns.forEach(function (b) {
      if (b.dataset.layout === currentLayout) {
        b.classList.add('is-active');
        b.setAttribute('aria-pressed', 'true');
      } else {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      }
    });

    // 3. Al hacer click, guardamos la preferencia y recargamos la página actual
    layoutBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.classList.contains('is-active')) return;

        animateReorder(function () {
          layoutBtns.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          if (grid) grid.dataset.layout = btn.dataset.layout;

          // Guardamos la elección en la memoria de la sesión
          sessionStorage.setItem('storefront_layout', btn.dataset.layout);

          // Redireccionamos manteniendo los parámetros (filtros, paginación, etc.)
          var url = new URL(window.location.href);
          url.searchParams.set('layout', btn.dataset.layout);
          history.replaceState(null, '', url.toString());
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var CART_SECTIONS = 'cart-drawer,cart-icon-bubble';

    function withDrawer(callback) {
      customElements.whenDefined('cart-drawer').then(function () {
        var drawer = document.querySelector('cart-drawer');
        if (drawer) callback(drawer);
      });
    }

    function openDrawerLoading(trigger) {
      withDrawer(function (drawer) {
        drawer.classList.add('is-loading');
        drawer.open(trigger);
      });
    }

    function finishDrawer(sections) {
      withDrawer(function (drawer) {
        if (typeof drawer.refresh === 'function') drawer.refresh(sections);
        drawer.classList.remove('is-loading');
      });
    }

    function failDrawer() {
      withDrawer(function (drawer) {
        drawer.classList.remove('is-loading');
        drawer.close();
      });
    }

    document.querySelectorAll('[data-product-card]').forEach(function (card) {
      var dataNode = card.querySelector('[data-product-card-variants]');
      var pricesNode = card.querySelector('[data-product-card-prices]');
      if (!dataNode) return;
      var variants;
      var prices = {};
      try { variants = JSON.parse(dataNode.textContent); } catch (e) { return; }
      if (pricesNode) {
        try { prices = JSON.parse(pricesNode.textContent); } catch (e) { prices = {}; }
      }
      if (!Array.isArray(variants) || variants.length === 0) return;

      var colorIndex = parseInt(card.dataset.colorOptionIndex, 10);
      var swatches = Array.prototype.slice.call(card.querySelectorAll('[data-product-card-swatch]'));
      var imageEl = card.querySelector('[data-product-card-image]');
      var priceEl = card.querySelector('[data-product-card-price]');
      var addBtn = card.querySelector('[data-product-card-add]');

      var selectedVariant = variants.find(function (v) { return v.available; }) || variants[0];

      function findVariantByColor(color) {
        if (colorIndex < 0) return null;
        var match = variants.find(function (v) {
          return v.options[colorIndex] === color && v.available;
        });
        if (match) return match;
        return variants.find(function (v) { return v.options[colorIndex] === color; });
      }

      function applyVariant(variant) {
        if (!variant) return;
        selectedVariant = variant;

        if (priceEl && prices[variant.id]) priceEl.textContent = prices[variant.id];

        if (imageEl && variant.featured_image && variant.featured_image.src) {
          imageEl.style.opacity = '0';
          var newSrc = variant.featured_image.src;
          var img = new Image();
          img.onload = function () {
            imageEl.src = newSrc;
            imageEl.srcset = '';
            imageEl.style.opacity = '';
          };
          img.src = newSrc;
        }

        if (addBtn) {
          addBtn.disabled = !variant.available;
          var label = variant.available ? addBtn.dataset.labelAvailable : addBtn.dataset.labelSoldOut;
          if (label) {
            addBtn.setAttribute('aria-label', label);
            addBtn.setAttribute('title', label);
          }
          if (variant.available) {
            addBtn.removeAttribute('aria-disabled');
          } else {
            addBtn.setAttribute('aria-disabled', 'true');
          }
        }

        if (colorIndex >= 0) {
          var current = variant.options[colorIndex];
          swatches.forEach(function (s) {
            var isSel = s.dataset.value === current;
            s.classList.toggle('is-selected', isSel);
            s.setAttribute('aria-checked', isSel);
          });
        }
      }

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function (e) {
          e.preventDefault();
          var variant = findVariantByColor(sw.dataset.value);
          applyVariant(variant);
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (addBtn.disabled || !selectedVariant) return;
          addBtn.classList.add('is-loading');
          openDrawerLoading(addBtn);
          var url = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js';
          fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              id: selectedVariant.id,
              quantity: 1,
              sections: CART_SECTIONS,
              sections_url: window.location.pathname
            })
          }).then(function (r) {
            if (!r.ok) throw new Error('cart add failed');
            return r.json();
          }).then(function (response) {
            addBtn.classList.remove('is-loading');
            addBtn.classList.add('is-success');
            finishDrawer(response.sections);
            document.dispatchEvent(new CustomEvent('cart:added', { detail: { variantId: selectedVariant.id } }));
            setTimeout(function () { addBtn.classList.remove('is-success'); }, 1200);
          }).catch(function () {
            addBtn.classList.remove('is-loading');
            failDrawer();
          });
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCarousel(carousel) {
      if (carousel.dataset.carouselInit) return;
      carousel.dataset.carouselInit = 'true';

      var track = carousel.querySelector('[data-carousel-track]');
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      var nav = carousel.querySelector('.product-carousel__nav');
      if (!track || !prev || !next) return;

      function update() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (nav) nav.classList.toggle('is-visible', maxScroll > 1);
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= maxScroll - 1;
      }

      function page(direction) {
        track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { page(-1); });
      next.addEventListener('click', function () { page(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-product-carousel]').forEach(initCarousel);
    }

    initAll();
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var track = gallery.querySelector('[data-gallery-track]');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
      var zoomTriggers = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-zoom]'));
      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      var lightbox = gallery.querySelector('[data-gallery-lightbox]');
      var lightboxImage = gallery.querySelector('[data-gallery-lightbox-image]');
      var lightboxCounter = gallery.querySelector('[data-gallery-lightbox-counter]');
      var lightboxPrev = gallery.querySelector('[data-gallery-lightbox-prev]');
      var lightboxNext = gallery.querySelector('[data-gallery-lightbox-next]');
      var lightboxCloseEls = gallery.querySelectorAll('[data-gallery-lightbox-close]');
      var lightboxDataEl = gallery.querySelector('[data-gallery-lightbox-data]');
      var lightboxImages = [];
      if (lightboxDataEl) {
        try {
          lightboxImages = JSON.parse(lightboxDataEl.textContent) || [];
        } catch (err) {
          lightboxImages = [];
        }
      }

      if (!track || slides.length === 0) return;

      var index = 0;
      var lightboxIndex = 0;
      var lastFocus = null;

      function go(i) {
        if (i < 0) i = 0;
        if (i > slides.length - 1) i = slides.length - 1;
        index = i;
        var slide = slides[i];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        thumbs.forEach(function (t, ti) {
          t.classList.toggle('is-active', ti === i);
        });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
      }

      function goToMediaId(id) {
        var i = slides.findIndex(function (s) { return s.dataset.mediaId === String(id); });
        if (i >= 0) go(i);
      }

      function openLightbox(startIndex) {
        if (!lightbox || lightboxImages.length === 0) return;
        lightboxIndex = Math.max(0, Math.min(startIndex, lightboxImages.length - 1));
        lastFocus = document.activeElement;
        renderLightbox();
        lightbox.hidden = false;
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', onLightboxKey);
        var firstClose = gallery.querySelector('[data-gallery-lightbox-close]');
        if (firstClose) firstClose.focus();
      }

      function closeLightbox() {
        if (!lightbox) return;
        lightbox.setAttribute('aria-hidden', 'true');
        lightbox.hidden = true;
        document.body.style.overflow = '';
        document.removeEventListener('keydown', onLightboxKey);
        if (lastFocus && typeof lastFocus.focus === 'function') {
          lastFocus.focus();
        }
      }

      function renderLightbox() {
        var item = lightboxImages[lightboxIndex];
        if (!item || !lightboxImage) return;
        lightboxImage.src = item.src;
        lightboxImage.alt = item.alt || '';
        if (lightboxCounter) {
          lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + lightboxImages.length;
        }
        if (lightboxPrev) lightboxPrev.disabled = lightboxIndex === 0;
        if (lightboxNext) lightboxNext.disabled = lightboxIndex === lightboxImages.length - 1;
        go(lightboxIndex);
      }

      function lightboxStep(delta) {
        if (lightboxImages.length === 0) return;
        var nextIdx = lightboxIndex + delta;
        if (nextIdx < 0) nextIdx = 0;
        if (nextIdx > lightboxImages.length - 1) nextIdx = lightboxImages.length - 1;
        if (nextIdx === lightboxIndex) return;
        lightboxIndex = nextIdx;
        renderLightbox();
      }

      function onLightboxKey(e) {
        if (e.key === 'Escape') { e.preventDefault(); closeLightbox(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); lightboxStep(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); lightboxStep(1); }
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          go(parseInt(thumb.dataset.index, 10));
        });
      });

      zoomTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          openLightbox(parseInt(trigger.dataset.index, 10) || 0);
        });
      });

      Array.prototype.forEach.call(lightboxCloseEls, function (el) {
        el.addEventListener('click', closeLightbox);
      });

      if (lightboxPrev) lightboxPrev.addEventListener('click', function () { lightboxStep(-1); });
      if (lightboxNext) lightboxNext.addEventListener('click', function () { lightboxStep(1); });

      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });

      gallery.addEventListener('keydown', function (e) {
        if (lightbox && lightbox.getAttribute('aria-hidden') === 'false') return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      });

      // Sync active thumbnail with manual scroll/swipe.
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var nearest = 0;
          var min = Infinity;
          slides.forEach(function (slide, i) {
            var d = Math.abs(slide.offsetLeft - track.scrollLeft);
            if (d < min) { min = d; nearest = i; }
          });
          if (nearest !== index) {
            index = nearest;
            thumbs.forEach(function (t, ti) {
              t.classList.toggle('is-active', ti === index);
            });
            if (prev) prev.disabled = index === 0;
            if (next) next.disabled = index === slides.length - 1;
          }
          ticking = false;
        });
      });

      // React to variant changes dispatched by the variant picker.
      document.addEventListener('variant:change', function (e) {
        var detail = e.detail || {};
        if (detail.featuredMediaId) goToMediaId(detail.featuredMediaId);
      });

      // Initialize.
      go(0);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var dataNode = picker.querySelector('[data-variant-data]');
      if (!dataNode) return;
      var variants;
      try { variants = JSON.parse(dataNode.textContent); } catch (e) { return; }
      if (!Array.isArray(variants) || variants.length === 0) return;

      var form = picker.closest('form') || document.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var unavailableNode = picker.querySelector('[data-variant-unavailable]');
      var priceNode = document.querySelector('[data-product-price]');
      var compareNode = document.querySelector('[data-product-compare-price]');
      var addBtn = form ? form.querySelector('[data-add-to-cart]') : null;
      var buyBtn = document.querySelector('[data-buy-now]');

      var optionGroups = Array.prototype.slice.call(picker.querySelectorAll('.variant-picker__option'));
      var selected = optionGroups.map(function (group) {
        var sel = group.querySelector('[role="radio"][aria-checked="true"]');
        return sel ? sel.dataset.optionValue : null;
      });

      function findVariant() {
        return variants.find(function (v) {
          return v.options.every(function (val, i) { return val === selected[i]; });
        });
      }

      function formatMoney(cents) {
        // Use Shopify currency formatting via the cart helper if available.
        if (window.Shopify && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(cents, window.Shopify.money_format);
        }
        return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'UYU' });
      }

      function updateUI() {
        var variant = findVariant();
        var available = variant && variant.available;

        // Update labels.
        optionGroups.forEach(function (group, i) {
          var labelValue = group.querySelector('[data-option-selected="' + i + '"]');
          if (labelValue) labelValue.textContent = selected[i] || '';
        });

        // Update aria-checked and is-selected classes.
        picker.querySelectorAll('[role="radio"]').forEach(function (btn) {
          var i = parseInt(btn.dataset.optionIndex, 10);
          var isSel = btn.dataset.optionValue === selected[i];
          btn.setAttribute('aria-checked', isSel);
          btn.classList.toggle('is-selected', isSel);
        });

        // Update price.
        if (variant && priceNode) priceNode.textContent = formatMoney(variant.price);
        if (compareNode) {
          if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareNode.textContent = formatMoney(variant.compare_at_price);
            compareNode.hidden = false;
          } else {
            compareNode.hidden = true;
          }
        }

        // Update hidden id and URL.
        if (variant && idInput) idInput.value = variant.id;
        if (variant) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }

        // Update CTAs.
        if (addBtn) {
          addBtn.disabled = !available;
          var addLabel = addBtn.querySelector('[data-add-label]');
          if (addLabel) {
            addLabel.textContent = available
              ? addBtn.dataset.labelAdd
              : addBtn.dataset.labelSoldOut;
          }
        }
        if (buyBtn) buyBtn.disabled = !available;
        if (unavailableNode) unavailableNode.hidden = !!available;

        // Notify gallery and other listeners.
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: {
            variant: variant,
            featuredMediaId: variant && variant.featured_media ? variant.featured_media.id : null,
            available: !!available
          }
        }));
      }

      picker.querySelectorAll('[role="radio"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var i = parseInt(btn.dataset.optionIndex, 10);
          selected[i] = btn.dataset.optionValue;
          updateUI();
        });
      });

      updateUI();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
